import { useState } from 'react';
import { useCreateChannelContext } from '@sendbird/uikit-react/CreateChannel/context';
import { useTranslate } from 'ra-core';
import { useHasPermission } from '../../../auth/useHasPermission';
import { Button } from '../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { ChannelModalCard } from './ChannelModalCard';
import { CreateGroupsModal } from './CreateGroupsModal';
import { CHANNEL_TYPE } from './types';

type SelectCreateGroupsModalProps = {
  open: boolean;
  onClose: () => void;
};

export const SelectCreateGroupsModal = ({
  open,
  onClose,
}: SelectCreateGroupsModalProps) => {
  const translate = useTranslate();
  const isAdmin = useHasPermission('ADMIN_ACCESS');
  const { setType } = useCreateChannelContext();
  const [openCreateGroups, setOpenCreateGroups] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleCreateGroup = () => {
    setType(CHANNEL_TYPE.GROUP);
    handleClose();
    setOpenCreateGroups(true);
  };

  const handleCreateSuperGroup = () => {
    setType(CHANNEL_TYPE.SUPERGROUP);
    handleClose();
    setOpenCreateGroups(true);
  };

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) handleClose();
        }}
      >
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>{translate('chat.createNewGroup')}</DialogTitle>
          </DialogHeader>
          <div className="grid gap-3">
            <ChannelModalCard
              onClick={handleCreateGroup}
              cardText="Group"
              type="GROUP"
            />
            {isAdmin && (
              <ChannelModalCard
                onClick={handleCreateSuperGroup}
                cardText="Supergroup"
                type="SUPERGROUP"
              />
            )}
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={handleClose}>
              {translate('chat.close')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <CreateGroupsModal
        open={openCreateGroups}
        onClose={() => setOpenCreateGroups(false)}
      />
    </>
  );
};
